module.exports = __webpack_public_path__ + "img/1602350754.30cb36af.png";